import React from 'react';
import { motion } from 'framer-motion';
export function Gallery() {
  const images = [{
    src: 'https://cdn.magicpatterns.com/uploads/3mrW9MjvudfW61TnD8UG2o/hongo3.jpg',
    alt: 'Reishi triple extracto'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/5PBdgMrkZ4YTPtx7gTzj5e/hongo2.jpg',
    alt: 'Cordyceps triple extracto'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/24uU26LFyRUjes6vSTcjwB/hongo1.jpg',
    alt: 'Melena de León triple extracto'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/nrT6gMZ5S5nQ9khweXk8fA/hongotodos.jpg',
    alt: 'Pack bienestar'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/nrT6gMZ5S5nQ9khweXk8fA/hongotodos.jpg',
    alt: 'Pack energía y enfoque'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/nrT6gMZ5S5nQ9khweXk8fA/hongotodos.jpg',
    alt: 'Presentación del producto'
  }];
  return <section className="py-24 bg-white" data-id="element-51">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="text-center mb-12" data-id="element-53">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-4xl font-heading font-bold text-brand-green mb-4" data-id="element-54">
            Fotos de nuestros productos
          </motion.h2>
          <p className="text-sm text-brand-brown/50 italic" data-id="element-55">
            Imágenes referenciales
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6" data-id="element-56">
          {images.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="aspect-square rounded-xl overflow-hidden bg-brand-beige group relative" data-id="element-57">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-58" />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4" data-id="element-59">
                <span className="text-white font-medium text-sm" data-id="element-60">
                  {img.alt}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}